import styled, { css } from 'styled-components'

import Media from 'builder/styles/media'
import Colors from 'builder/styles/colors'
import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

import { WidgetImage } from '../../widget.styles'
import BadScore from './assets/badScore.png'
import GoodScore from './assets/goodScore.png'
import AverageScore from './assets/averageScore.png'

export const ActionContainer = styled.button<{ $isPhone?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;

  padding: 11px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};

  ${({ $isPhone }) =>
    $isPhone &&
    css`
      ${Media.Phone`
        flex-direction: row-reverse;
        justify-content: center;
        gap: 4px;
      `}
    `}
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const ActionCredit = styled.p`
  ${Typography.Body}
  ${FontWeights.DemiBold}

  color: ${Colors.Green50};
`

export const IlustrationContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  position: relative;
  overflow: hidden;

  ${Media.Phone`
    height: 160px;
  `}
`

export const Image = styled(WidgetImage)``

export const ImageContainer = styled.div<{ $isPreview?: boolean }>`
  width: 100%;
  height: 100%;

  ${({ $isPreview }) =>
    $isPreview &&
    css`
      padding-top: 40px;
      padding-left: 32px;
      padding-right: 96px;

      ${Media.Phone`
        padding: 0;
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 26px;
        padding-left: 64px;

        ${Image} {
          width: 137px;
          margin: 0;
          position: unset;
          transform: none;
        }
      `}
    `}
`

export const ScoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 64px;
  position: absolute;
  top: 42px;
  right: 20px;

  ${Media.Phone`
    position: unset;
  `}
`

export const ScoreText = styled.p`
  ${Typography.Caption}
  ${FontWeights.Medium}

  color: ${Colors.Blue80};
  opacity: 0.6;
`

export const Score = styled.div<{ $background: string }>`
  padding: 2px 4px 2px 6px;
  border-radius: 8px;

  width: fit-content;

  ${Typography.Body}
  ${FontWeights.DemiBold}
  color: ${Colors.White};

  ${({ $background }) => css`
    background: ${$background};
  `}
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`

export const IlustrationOverlay = styled.div<{ $score: number }>`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 16px;

  ${Media.Phone`
    height: 48px;
  `}

  ${({ $score }) => {
    if ($score >= 70) {
      return css`
        background: url(${GoodScore}) no-repeat;

        ${Media.Phone`
          background: linear-gradient(177deg, rgba(231, 243, 255, 0.00) 2.33%, #E7F3FB 97.87%);
        `}
      `
    }

    if ($score >= 30) {
      return css`
        background: url(${AverageScore}) no-repeat;

        ${Media.Phone`
          background: linear-gradient(177deg, rgba(231, 243, 255, 0.00) 2.33%, #ECF3F4 97.87%);
        `}
      `
    }

    return css`
      background: url(${BadScore}) no-repeat;

      ${Media.Phone`
        background: linear-gradient(177deg, rgba(231, 243, 255, 0.00) 2.33%, #EDF2FC 97.87%);
      `}
    `
  }}
`
